













































































import {
  defineComponent, PropType, ref, toRefs, computed,
} from '@vue/composition-api'
import { mdiTrashCanOutline } from '@mdi/js'
import { AggregationUserAttrs } from '@/api/v2/report/AggregationUser'
import { UserAttrs } from '@/api/v2/report/Aggregation'
import GroupedCombobox from '@/views/v2-temp/common/components/GroupedCombobox.vue'

export default defineComponent({
  name: 'AggregationUsersDialogListItem',
  components: {
    GroupedCombobox,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    aggregationUsers: {
      type: Array as PropType<AggregationUserAttrs[]>,
      default: () => [],
    },
    availableUsers: {
      type: Array as PropType<UserAttrs[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const { availableUsers } = toRefs(props)

    const selectedUserId = ref<number | null>(null)
    const loading = ref(false)
    const userGroups = [
      { header: 'キャスト', key: 'cast' },
      { header: 'スタッフ', key: 'waiter' },
      { header: 'アライアンス', key: 'alliance' },
    ]

    const selectedUserName = computed(() => {
      if (!selectedUserId.value) return ''

      return availableUsers.value.find(user => user.id === selectedUserId.value)?.name || null
    })

    const fetchAvailableUsers = () => {
      if (loading.value) return

      loading.value = true
      const callback = () => { loading.value = false }
      emit('fetch-available-users', callback)
    }

    const onUserSelect = (item: UserAttrs | null) => {
      if (loading.value) return

      if (item?.id) {
        loading.value = true
        const callback = () => {
          loading.value = false
          selectedUserId.value = null
        }

        selectedUserId.value = item.id
        emit('create', { userId: item.id, callback })
      }
    }

    const destroy = (aggregationUser: AggregationUserAttrs) => {
      if (loading.value) return

      const callback = () => { loading.value = false }
      emit('destroy', {
        id: aggregationUser.id,
        userId: aggregationUser.userId,
        callback,
      })
    }

    return {
      selectedUserId,
      selectedUserName,
      userGroups,

      fetchAvailableUsers,
      onUserSelect,
      destroy,

      icons: {
        mdiTrashCanOutline,
      },
    }
  },
})
